import SvgIconStyle from 'components/SvgIconStyle';
import { PATH_DASHBOARD } from 'routers/paths';

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  booking: getIcon('ic_booking'),
  kanban: getIcon('ic_kanban'),
  region: getIcon('ic_region'),
  settings: getIcon('ic_settings'),
  users: getIcon('ic_users'),
  bonus: getIcon('ic_flash'),
  notValidatedClasses: getIcon('ic_analytics'),
  usersAttendanceReportStudioFacilityAdmin: getIcon('ic_dashboard'),
  influencers: getIcon('ic_influencers'),
  oakleyBenefits: getIcon('ic_benefits'),
  challenge: getIcon('ic_challenge'),
  corporate: getIcon('ic_corporate'),
  reports: getIcon('ic_dashboard'),
  brands: getIcon('ic_brands'),
  colors: getIcon('ic_colors'),
  vendor: getIcon('ic_vendor'),
  product: getIcon('ic_product'),
  progress: getIcon('ic_progress'),
  order: getIcon('ic_order'),
  voucher: getIcon('ic_voucher'),
  personalTrainers: getIcon('ic_personalTrainer'),
  allProducts: getIcon('ic_allProducts'),
  oakleyEvents: getIcon('ic_oakley'),
};

const getGeneralPath = (path) => `general${path}`;
const getSettingsPath = (path) => `settings${path}`;
const getShopPath = (path) => `shop${path}`;
const getReportsPath = (path) => `reports${path}`;

export const getYfcAdminNavBar = () => [
  {
    subheader: 'general',
    items: [
      {
        title: 'Registered Users',
        path: getGeneralPath(PATH_DASHBOARD.registeredUsers.root),
        icon: ICONS.reports,
      },
      { title: 'Facilities', path: getGeneralPath(PATH_DASHBOARD.facility.root), icon: ICONS.kanban },
      {
        title: 'Not Validated Classes',
        path: getGeneralPath(PATH_DASHBOARD.notValidatedClasses.root),
        icon: ICONS.notValidatedClasses,
      },
      { title: 'Licensed Providers', path: getGeneralPath(PATH_DASHBOARD.licensedProviders.root), icon: ICONS.booking },
      { title: 'Challenges', path: getGeneralPath(PATH_DASHBOARD.challenges.root), icon: ICONS.challenge },
      { title: 'Corporate', path: getGeneralPath(PATH_DASHBOARD.corporate.root), icon: ICONS.corporate },
      {
        title: 'Personal Trainers',
        path: getGeneralPath(PATH_DASHBOARD.personalTrainers.root),
        icon: ICONS.personalTrainers,
      },
      {
        title: 'Oakley Events',
        path: getGeneralPath(PATH_DASHBOARD.oakleyEvents.root),
        icon: ICONS.oakleyEvents,
      },
    ],
  },
  {
    subheader: 'settings',
    items: [
      { title: 'Regions', path: getSettingsPath(PATH_DASHBOARD.regions.root), icon: ICONS.region },
      { title: 'Global Settings', path: getSettingsPath(PATH_DASHBOARD.globalSettings.root), icon: ICONS.settings },
      { title: 'YFC Users', path: getSettingsPath(PATH_DASHBOARD.users.root), icon: ICONS.users },
      { title: 'Bonuses List', path: getSettingsPath(PATH_DASHBOARD.bonuses.root), icon: ICONS.bonus },
      {
        title: 'Oakley Benefits',
        path: getSettingsPath(PATH_DASHBOARD.oakleyBenefits.root),
        icon: ICONS.oakleyBenefits,
      },
      { title: 'Influencers', path: getSettingsPath(PATH_DASHBOARD.influencers.root), icon: ICONS.influencers },
      { title: 'Progress Levels', path: getSettingsPath(PATH_DASHBOARD.progressLevels.root), icon: ICONS.progress },
    ],
  },
  {
    subheader: 'shop',
    items: [
      { title: 'All Products', path: getShopPath(PATH_DASHBOARD.allProducts.root), icon: ICONS.allProducts },
      {
        title: 'Vendors',
        path: getShopPath(PATH_DASHBOARD.vendors.root),
        icon: ICONS.vendor,
      },
      {
        title: 'Orders',
        path: getShopPath(PATH_DASHBOARD.ordersYFC.root),
        icon: ICONS.order,
      },
      {
        title: 'Voucher Orders',
        path: getShopPath(PATH_DASHBOARD.voucherOrder.root),
        icon: ICONS.voucher,
      },
      { title: 'Brands', path: getShopPath(PATH_DASHBOARD.brands.root), icon: ICONS.brands },
      {
        title: 'Colors',
        path: getShopPath(PATH_DASHBOARD.colors.root),
        icon: ICONS.colors,
      },
    ],
  },
  {
    subheader: 'reports',
    items: [
      {
        title: 'Challenge Activity Report',
        path: getReportsPath(PATH_DASHBOARD.challengesActivityReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'Dubai 30x30 Report',
        path: getReportsPath(PATH_DASHBOARD.dubai3030Report.root),
        icon: ICONS.reports,
      },
      {
        title: 'User Referral Report',
        path: getReportsPath(PATH_DASHBOARD.userReferralReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'User Access Report',
        path: getReportsPath(PATH_DASHBOARD.userAccessReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'Challenges Report',
        path: getReportsPath(PATH_DASHBOARD.challengesReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'User Subscriptions',
        path: getReportsPath(PATH_DASHBOARD.userSubscriptions.root),
        icon: ICONS.reports,
      },
      {
        title: 'User Oakley Subscriptions',
        path: getReportsPath(PATH_DASHBOARD.userOakleySubscriptions.root),
        icon: ICONS.reports,
      },
      {
        title: 'PT Commissions Report',
        path: getReportsPath(PATH_DASHBOARD.personalTrainersCommissionReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'PT Package Sales Report',
        path: getReportsPath(PATH_DASHBOARD.personalTrainersSalesReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'Class Credits Report',
        path: getReportsPath(PATH_DASHBOARD.classCreditsReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'Gym Attendance With RL',
        path: getReportsPath(PATH_DASHBOARD.gymAttendanceWithRedLine.root),
        icon: ICONS.reports,
      },
      {
        title: 'Gym Attendance Report',
        path: getReportsPath(PATH_DASHBOARD.gymAttendanceReports.root),
        icon: ICONS.reports,
      },
      {
        title: 'Influencer Report',
        path: getReportsPath(PATH_DASHBOARD.influencersReports.root),
        icon: ICONS.reports,
      },
      {
        title: 'Itemized Sales Report',
        path: getReportsPath(PATH_DASHBOARD.itemizedSalesReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'Retail Sales Report',
        path: getReportsPath(PATH_DASHBOARD.retailSalesReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'Vendor Sales Report',
        path: getReportsPath(PATH_DASHBOARD.vendorSalesReport.root),
        icon: ICONS.reports,
      },
    ],
  },
];

export const getSuperAdminNavBar = () => [...getYfcAdminNavBar()];

export const getFranchiseRegionAdmin = () => [
  {
    subheader: 'general',
    items: [
      {
        title: 'Registered Users',
        path: getGeneralPath(PATH_DASHBOARD.registeredUsers.root),
        icon: ICONS.reports,
      },
      { title: 'Facilities', path: getGeneralPath(PATH_DASHBOARD.facility.root), icon: ICONS.kanban },
      {
        title: 'Not Validated Classes',
        path: getGeneralPath(PATH_DASHBOARD.notValidatedClasses.root),
        icon: ICONS.notValidatedClasses,
      },
      { title: 'Licensed Providers', path: getGeneralPath(PATH_DASHBOARD.licensedProviders.root), icon: ICONS.booking },
      { title: 'Challenges', path: getGeneralPath(PATH_DASHBOARD.challenges.root), icon: ICONS.challenge },
      { title: 'Corporate', path: getGeneralPath(PATH_DASHBOARD.corporate.root), icon: ICONS.corporate },
      {
        title: 'Personal Trainers',
        path: getGeneralPath(PATH_DASHBOARD.personalTrainers.root),
        icon: ICONS.personalTrainers,
      },
    ],
  },
  {
    subheader: 'settings',
    items: [
      { title: 'Regions', path: getSettingsPath(PATH_DASHBOARD.regions.root), icon: ICONS.region },
      { title: 'YFC Users', path: getSettingsPath(PATH_DASHBOARD.users.root), icon: ICONS.users },
      { title: 'Influencers', path: getSettingsPath(PATH_DASHBOARD.influencers.root), icon: ICONS.influencers },
    ],
  },
  {
    subheader: 'shop',
    items: [
      {
        title: 'Vendors',
        path: getShopPath(PATH_DASHBOARD.vendors.root),
        icon: ICONS.vendor,
      },
      {
        title: 'Orders',
        path: getShopPath(PATH_DASHBOARD.ordersYFC.root),
        icon: ICONS.order,
      },
      {
        title: 'Voucher Orders',
        path: getShopPath(PATH_DASHBOARD.voucherOrder.root),
        icon: ICONS.voucher,
      },
    ],
  },
  {
    subheader: 'reports',
    items: [
      {
        title: 'User Referral Report',
        path: getReportsPath(PATH_DASHBOARD.userReferralReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'User Access Report',
        path: getReportsPath(PATH_DASHBOARD.userAccessReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'Challenges Report',
        path: getReportsPath(PATH_DASHBOARD.challengesReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'User Subscriptions',
        path: getReportsPath(PATH_DASHBOARD.userSubscriptions.root),
        icon: ICONS.reports,
      },
      {
        title: 'User Oakley Subscriptions',
        path: getReportsPath(PATH_DASHBOARD.userOakleySubscriptions.root),
        icon: ICONS.reports,
      },
      {
        title: 'PT Commissions Report',
        path: getReportsPath(PATH_DASHBOARD.personalTrainersCommissionReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'PT Package Sales Report',
        path: getReportsPath(PATH_DASHBOARD.personalTrainersSalesReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'Class Credits Report',
        path: getReportsPath(PATH_DASHBOARD.classCreditsReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'Gym Attendance With RL',
        path: getReportsPath(PATH_DASHBOARD.gymAttendanceWithRedLine.root),
        icon: ICONS.reports,
      },
      {
        title: 'Gym Attendance Report',
        path: getReportsPath(PATH_DASHBOARD.gymAttendanceReports.root),
        icon: ICONS.reports,
      },
      {
        title: 'Influencer Report',
        path: getReportsPath(PATH_DASHBOARD.influencersReports.root),
        icon: ICONS.reports,
      },
      {
        title: 'Itemized Sales Report',
        path: getReportsPath(PATH_DASHBOARD.itemizedSalesReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'Retail Sales Report',
        path: getReportsPath(PATH_DASHBOARD.retailSalesReport.root),
        icon: ICONS.reports,
      },
      {
        title: 'Vendor Sales Report',
        path: getReportsPath(PATH_DASHBOARD.vendorSalesReport.root),
        icon: ICONS.reports,
      },
    ],
  },
];

export const getFacilityGymAdminNavBar = () => [
  {
    subheader: 'general',
    items: [{ title: 'Facilities', path: getGeneralPath(PATH_DASHBOARD.facility.root), icon: ICONS.kanban }],
  },
  {
    subheader: 'reports',
    items: [
      {
        title: 'Gym User Attendance',
        path: getReportsPath(PATH_DASHBOARD.usersAttendanceGymReportFacilityAdmin.root),
        icon: ICONS.reports,
      },
      {
        title: 'Access Report',
        path: getReportsPath(PATH_DASHBOARD.userAccessReportGymFacilityAdmin.root),
        icon: ICONS.reports,
      },
    ],
  },
];

export const getFacilityStudioAdminNavBar = () => [
  {
    subheader: 'general',
    items: [{ title: 'Facilities', path: getGeneralPath(PATH_DASHBOARD.facility.root), icon: ICONS.kanban }],
  },
  {
    subheader: 'reports',
    items: [
      {
        title: 'Studio User Attendance',
        path: getReportsPath(PATH_DASHBOARD.usersAttendanceReportStudioFacilityAdmin.root),
        icon: ICONS.reports,
      },
      {
        title: 'Studio Attendance Per Class',
        path: getReportsPath(PATH_DASHBOARD.studioAttendancePerClassReport.root),
        icon: ICONS.reports,
      },
    ],
  },
];

export const getVendorAdminNavBar = () => [
  {
    subheader: 'shop',
    items: [
      {
        title: 'Products',
        path: PATH_DASHBOARD.vendors.goProductsVendorAdmin,
        icon: ICONS.product,
      },
      {
        title: 'Voucher Orders',
        path: getShopPath(PATH_DASHBOARD.voucherOrder.root),
        icon: ICONS.voucher,
      },
      {
        title: 'Orders',
        path: getShopPath(PATH_DASHBOARD.ordersVendor.root),
        icon: ICONS.order,
      },
      { title: 'Brands', path: getShopPath(PATH_DASHBOARD.brands.root), icon: ICONS.brands },
      {
        title: 'Colors',
        path: getShopPath(PATH_DASHBOARD.colors.root),
        icon: ICONS.colors,
      },
    ],
  },
  {
    subheader: 'reports',
    items: [
      {
        title: 'Vendor Sales Report',
        path: getReportsPath(PATH_DASHBOARD.vendorSalesReport.root),
        icon: ICONS.reports,
      },
    ],
  },
];

export const getChallengeAdminNavBar = () => [
  {
    subheader: 'general',
    items: [{ title: 'Challenges', path: getGeneralPath(PATH_DASHBOARD.challenges.root), icon: ICONS.challenge }],
  },
  {
    subheader: 'Reports',
    items: [
      {
        title: 'Challenge Activity Report',
        path: getReportsPath(PATH_DASHBOARD.challengesActivityReport.root),
        icon: ICONS.reports,
      },
    ],
  },
];
